import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResponsiveImage = _resolveComponent("ResponsiveImage")!

  return (_openBlock(), _createBlock(_component_ResponsiveImage, {
    "is-product-image": "",
    mode: "contain",
    class: "object-contain",
    "image-url": _ctx.url,
    alt: _ctx.alt,
    lazy: _ctx.lazy,
    "aspect-ratio": _ctx.aspectRatio,
    "width-on-screen": _ctx.widthOnScreen,
    "bg-color": _ctx.bgColor,
    "cache-bust": _ctx.cacheBust,
    "hide-press-mode-button": _ctx.hidePressModeButton
  }, null, 8, ["image-url", "alt", "lazy", "aspect-ratio", "width-on-screen", "bg-color", "cache-bust", "hide-press-mode-button"]))
}